// cspell:ignore dataavailable
import { checkForAudioTracks, getAudioStream } from 'hume';
import { useCallback, useRef, useState } from 'react';

type PermissionStatus = 'prompt' | 'granted' | 'denied';

type UseEncodingProps = {
  withMicrophone: boolean;
};

const useEncoding = (
  { withMicrophone }: UseEncodingProps = { withMicrophone: true },
) => {
  const [permission, setPermission] = useState<PermissionStatus>('prompt');
  const streamRef = useRef<MediaStream | null>(null);

  const getStream = useCallback(async () => {
    if (!withMicrophone) {
      setPermission('granted');
      return 'granted' as const;
    }

    try {
      const stream = await getAudioStream();
      setPermission('granted');
      streamRef.current = stream;
      checkForAudioTracks(stream);
      return 'granted' as const;
    } catch (e) {
      setPermission('denied');
      streamRef.current = null;
      return 'denied' as const;
    }
  }, [withMicrophone]);

  return {
    streamRef,
    getStream,
    permission,
  };
};

export { useEncoding };
